import { routerGetCall } from '../../axios';

const getGuestRegistrationDetails = (state, params) => {
    const url = `/accounts/quote/${params.id}/user`;
    const getData = routerGetCall(state, url, params);
    return getData;
};

export default { getGuestRegistrationDetails };
